import React from 'react';
import { Card, Tabs, Collapse, Button, Empty, Spin } from 'antd';
import { PrinterOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { initHandler, ajaxViewHandler, setConfig } from '../../store/actions';
import { Helmet } from 'react-helmet';
import Config from '../../Config';
import { resolveMediaUrls } from '../../utils/dokumentasiHtml';

const { TabPane } = Tabs;
const { Panel } = Collapse;

const configClass = {
	title: 'Panduan Pengguna',
	apiUrl: { kategori: 'dokumentasi/api/kategori/' },
};

const config = new Config();

// Halaman ini SENGAJA tidak digerbang hak_akses (lihat routing di
// AdminLayout.jsx - plain <Route>, bukan <LayananRoute isAkses={...}>) -
// panduan pengguna harus bisa dibaca SEMUA orang yang login, apa pun
// jabatannya. Yang digerbang hanya kemampuan EDIT (lihat FormPanduan.jsx).
class DataPanduan extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			listKategori: [],
			activeTab: null,
			isMobile: window.innerWidth <= 768,
		};
	}

	UNSAFE_componentWillMount() { this.props.initHandler(); }

	componentDidMount() {
		this._handleResize = () => this.setState({ isMobile: window.innerWidth <= 768 });
		window.addEventListener('resize', this._handleResize);
		this.fetchData();
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this._handleResize);
	}

	fetchData = () => {
		this.setState({ loading: true });
		this.props.ajaxViewHandler('get', configClass.apiUrl.kategori)
			.then(() => {
				if (this.props.isSuccess) {
					const data = this.props.responseMsg;
					const list = Array.isArray(data) ? data : (data.results || []);
					this.setState({
						listKategori: list,
						activeTab: list.length ? String(list[0].id) : null,
					});
				}
				this.setState({ loading: false });
			})
			.catch(() => this.setState({ loading: false }));
	};

	handleCetak = () => {
		window.print();
	};

	render() {
		const { loading, listKategori, activeTab, isMobile } = this.state;
		const canEdit = !!(this.props.akses && this.props.akses.pengaturan_dokumentasi);

		return (
			<div>
				<Helmet>
					<title>{configClass.title + ' | ' + config.get_site_info().name}</title>
					<style>{`
						.panduan-wrap .ant-tabs-nav { margin-bottom: 16px; }
						.panduan-konten h4 {
							color: #0f2847; font-size: 15px; font-weight: 700; margin: 18px 0 8px;
							padding-left: 10px; border-left: 4px solid #1e4d8a;
						}
						.panduan-konten p { font-size: 13.5px; color: #333; line-height: 1.7; margin: 0 0 10px; }
						.panduan-konten ul { margin: 0 0 12px; padding-left: 22px; }
						.panduan-konten li { font-size: 13.5px; color: #333; line-height: 1.7; margin-bottom: 4px; }
						.panduan-konten img {
							max-width: 100%; height: auto; border-radius: 8px;
							border: 1px solid #e5e9f0; box-shadow: 0 2px 10px rgba(0,0,0,0.06);
							margin: 6px 0;
						}
						.panduan-konten em { color: #64748b; font-size: 12.5px; }

						/* ===== Cetak / Simpan PDF - reuse tampilan layar apa adanya,
						   sembunyikan chrome navigasi, WAJIB paksa semua Collapse
						   terbuka (default AntD collapsed = display:none, kalau
						   tidak dipaksa, isi yang belum dibuka user tidak ikut cetak) ===== */
						@media print {
							.panduan-no-print { display: none !important; }
							.ant-collapse-content { display: block !important; height: auto !important; }
							.ant-collapse-content-box { display: block !important; }
							.ant-tabs-nav { display: none !important; }
							.ant-tabs-tabpane { display: block !important; }
							.panduan-wrap .ant-collapse-item { break-inside: avoid; }
						}
					`}</style>
				</Helmet>

				<Card className="panduan-wrap" style={{ borderRadius: 14, boxShadow: '0 4px 20px rgba(0,0,0,0.07)', overflow: 'hidden' }} bodyStyle={{ padding: 0 }}>
					<div className="panduan-no-print" style={{
						padding: '16px 20px',
						background: 'linear-gradient(135deg, #0f2847 0%, #1a3a6b 100%)',
						display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12,
					}}>
						<div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
							<div style={{ width: 38, height: 38, background: 'rgba(251,191,36,0.15)', borderRadius: 10,
								display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 19 }}>📖</div>
							<div>
								<div style={{ fontSize: 15, fontWeight: 700, color: '#fff' }}>Panduan Pengguna E-SAMSAT</div>
								<div style={{ fontSize: 11, color: '#94a3b8', marginTop: 1 }}>Transaksi • Laporan • Berita Acara • Gudang Notice • Migrasi Legacy</div>
							</div>
						</div>
						<div style={{ display: 'flex', gap: 8 }}>
							{canEdit && (
								<Link to="/admin/panduan/edit">
									<Button style={{ borderRadius: 8, background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff' }}>
										Edit Panduan
									</Button>
								</Link>
							)}
							<Button
								type="primary"
								icon={<PrinterOutlined />}
								onClick={this.handleCetak}
								style={{ borderRadius: 8, background: '#fff', color: '#0f2847', border: 'none', fontWeight: 600 }}
							>
								{!isMobile && 'Cetak / Simpan PDF'}
							</Button>
						</div>
					</div>

					<div style={{ padding: isMobile ? 14 : 22 }}>
						{loading ? (
							<div style={{ textAlign: 'center', padding: 60 }}><Spin size="large" /></div>
						) : listKategori.length === 0 ? (
							<Empty description="Belum ada panduan tersedia" style={{ padding: 60 }} />
						) : (
							<Tabs activeKey={activeTab} onChange={(k) => this.setState({ activeTab: k })}>
								{listKategori.map((kat) => (
									<TabPane tab={kat.nama} key={String(kat.id)}>
										{(!kat.bagian || kat.bagian.length === 0) ? (
											<Empty description="Belum ada bagian di kategori ini" />
										) : (
											<Collapse defaultActiveKey={[String(kat.bagian[0].id)]}>
												{kat.bagian.map((b) => (
													<Panel header={<span style={{ fontWeight: 600, color: '#0f2847' }}>{b.judul}</span>} key={String(b.id)}>
														<div
															className="panduan-konten"
															dangerouslySetInnerHTML={{ __html: resolveMediaUrls(b.isi) }}
														/>
													</Panel>
												))}
											</Collapse>
										)}
									</TabPane>
								))}
							</Tabs>
						)}
					</div>
				</Card>
			</div>
		);
	}
}

const mapStateToProps = (state) => state.configReducers;

export default connect(
	mapStateToProps,
	{ initHandler, setConfig, ajaxViewHandler }
)(DataPanduan);
